//Api or Services
import { modulesName } from '@/modules';
import AnswerProvisionalRemedy from '@/modules/student-answer-rp/api';
import { ACTION_TYPES, MUTATION_TYPES } from './types';

const actions = {
  async [ACTION_TYPES.GET_FILTERS]({ commit }) {
    const requests = [
      await AnswerProvisionalRemedy.getAcademicYearsAnswerRequest(),
      await AnswerProvisionalRemedy.getRequestServiceStatus(),
      await AnswerProvisionalRemedy.getRequestServiceType(),
    ];

    const [acadmicYears, serviceStatus, serviceType] = await Promise.all(
      requests
    );

    commit(MUTATION_TYPES.SET_ACADEMICYEARS, acadmicYears);
    commit(MUTATION_TYPES.SET_SERVICESTATUS, serviceStatus);
    commit(MUTATION_TYPES.SET_SERVICETYPES, serviceType);
  },

  async [ACTION_TYPES.GET_RESULTS_FILTERED](context, filters) {
    //set current filters
    if (filters == undefined) {
      filters = context.state.currentFilters; //Search for the lastest filters
    } else {
      context.commit(MUTATION_TYPES.SET_CURRENT_FILTERS, filters);
    }

    const response = await AnswerProvisionalRemedy.getAnswerRequestRpHistory(
      filters
    );
    if (response) {
      context.commit(MUTATION_TYPES.SET_RESULTS_FILTERED, response);
    }
  },
  async [ACTION_TYPES.GET_REASONS_BY_ACTION_ID]({ state, commit }, id) {
    //set current filters
    if (state.reasons[id] == null) {
      const response = await AnswerProvisionalRemedy.getReasonsBy(id);
      if (response) {
        commit(MUTATION_TYPES.SET_REASONS, { id: id, reasons: response });
      }
    }
  },
  async [ACTION_TYPES.SAVE_DETERMINATION](context, payload) {
    //set current filters
    const response = await AnswerProvisionalRemedy.saveDetermination(
      payload.serviceId,
      payload.info
    ).catch((e) => {
      context.dispatch(
        `${modulesName.appModuleName}/showToast`,
        {
          message: e,
          type: 'error', //Puede ser un enum o quizas solo llamar un metodo con esto
        },
        { root: true }
      );
    });
    if (response) {
      await context.dispatch(ACTION_TYPES.GET_RESULTS_FILTERED);
      await context.dispatch(
        `${modulesName.appModuleName}/showToast`,
        {
          message: 'Cambio de estatus exitosamente.',
          type: 'success', //Puede ser un enum o quizas solo llamar un metodo con esto
        },
        { root: true }
      );
    }
  },
};

export default actions;
